import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/**
 * Formats API date-only values sent as midnight datetimes (e.g. 2026-05-14T00:00:00Z)
 * without shifting the calendar day in the viewer's timezone.
 */
export function formatCalendarDate(
  value: string | null | undefined,
  options?: Intl.DateTimeFormatOptions
): string {
  if (!value?.trim()) return '—';
  const datePart = value.trim().slice(0, 10);
  const parsed = dayjs(datePart, 'YYYY-MM-DD', true);
  if (!parsed.isValid()) return value;
  const [y, m, d] = datePart.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString(undefined, {
    ...options,
    timeZone: 'UTC',
  });
}
